import type React from 'react';
import { InOfficeHoldNoteContent } from './InOfficeHoldNoteContent';
import { hasInOfficeHoldNoteContent } from './inOfficeHoldNote';
import type { OriginEventRendererProps } from './types';

export type { OriginEventRendererProps } from './types';

export interface OriginEventRendererEntry {
    /** Whether the payload has anything worth showing for this type. */
    hasContent: (payload: Record<string, unknown>) => boolean;
    Component: React.FC<OriginEventRendererProps>;
}

/**
 * Origin-event `type` -> renderer for OdoNoteCard's event-specific body.
 * Local port of the dashboard's originEventRenderers/ registry (see
 * dashboard/src/components/appointments/originEventRenderers/) - an
 * unrecognized/unhandled type renders nothing, same safe default.
 */
export const ORIGIN_EVENT_RENDERERS: Record<string, OriginEventRendererEntry> = {
    'in-office-hold-note': {
        hasContent: hasInOfficeHoldNoteContent,
        Component: InOfficeHoldNoteContent
    }
};
